<div class="mt-4 w-full divide-y divide-neutral-5 rounded-3xl border border-neutral-5">
  <div class="flex w-full flex-col p-5">
    <div
      class="flex flex-row items-center justify-between"
      [ngClass]="activeSetup === 'sms' ? 'hover:cursor-pointer hover:text-primary-100' : 'hover:cursor-default'"
      (click)="toggleActiveSetup()">
      <div class="flex flex-row items-center">
        <div class="flex items-center rounded border border-neutral-5">
          <pay-icon [size]="'sm'" class="p-3" [shape]="IconNames.MobileCheck" />
        </div>
        <span class="ml-4 font-bold">{{ 'setup-two-factor-auth.qr.header.label' | translate }}</span>
      </div>
      <pay-icon [shape]="activeSetup === 'app' ? IconNames.ChevronDown : IconNames.ChevronUp" />
    </div>
    <div
      [ngClass]="activeSetup === 'app' ? 'max-h-[100rem] opacity-100' : 'max-h-0 overflow-hidden opacity-0'"
      class="transition-[max-height,opacity] duration-500 ease-in-out">
      <div class="transition-all duration-500 ease-in-out" [ngClass]="activeSetup === 'app' ? 'clip-path-unset' : 'clip-path-hidden'">
        <pay-login-setup-two-factor-auth-app [mfaBearer]="mfaBearer()" />
      </div>
    </div>
  </div>
  <div class="flex w-full flex-col p-5">
    <div
      class="flex flex-row items-center justify-between"
      [ngClass]="activeSetup === 'app' ? 'hover:cursor-pointer hover:text-primary-100' : 'hover:cursor-default'"
      (click)="toggleActiveSetup()">
      <div class="flex flex-row items-center">
        <div class="flex items-center rounded border border-neutral-5">
          <pay-icon [size]="'sm'" class="p-3" [shape]="IconNames.Sms" />
        </div>
        <span class="ml-4 font-bold">{{ 'setup-two-factor-auth.sms.header.label' | translate }}</span>
      </div>
      <pay-icon [shape]="activeSetup === 'sms' ? IconNames.ChevronDown : IconNames.ChevronUp" />
    </div>
    <div
      [ngClass]="activeSetup === 'sms' ? 'opacity-100' : 'max-h-0 overflow-hidden opacity-0'"
      class="transition-[max-height,opacity] duration-500 ease-in-out">
      <div class="transition-all duration-500 ease-in-out" [ngClass]="activeSetup === 'sms' ? 'clip-path-unset' : 'clip-path-hidden'">
        <pay-login-setup-two-factor-auth-sms />
      </div>
    </div>
  </div>
</div>
